/* Oud Library policy pages: adds the links between the policies and an "On this page" list built from the policy's
   own section headings (h2). Shopify renders the policy markup, so this only adds navigation; without it the page still
   reads top to bottom. Loaded on policy pages only. */
(() => {
  'use strict';
  const box = document.querySelector('.shopify-policy__container');
  const body = box && box.querySelector('.shopify-policy__body');
  if (!box || !body || box.dataset.olPolicy) return;
  box.dataset.olPolicy = 'ready';

  // 1. Links to every policy, the current one marked
  const policies = [
    ['/policies/privacy-policy', 'Privacy policy'],
    ['/policies/refund-policy', 'Refund policy'],
    ['/policies/shipping-policy', 'Shipping policy'],
    ['/policies/terms-of-service', 'Terms of service'],
    ['/policies/contact-information', 'Contact information']
  ];
  const here = location.pathname.replace(/\/$/, '');
  const switcher = document.createElement('nav');
  switcher.className = 'ol-policy-switch';
  switcher.setAttribute('aria-label', 'Policies');
  const list = document.createElement('ul');
  for (const [href, label] of policies) {
    const li = document.createElement('li'), a = document.createElement('a');
    a.href = href; a.textContent = label;
    if (here.endsWith(href)) a.setAttribute('aria-current', 'page');
    li.append(a); list.append(li);
  }
  switcher.append(list);
  const title = box.querySelector('.shopify-policy__title');
  (title || body).after(switcher);

  // 'Change your cookie settings' links reopen Shopify's cookie banner
  body.querySelectorAll('.ol-cookie-settings').forEach(link => link.addEventListener('click', event => {
    const banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') { event.preventDefault(); banner.showPreferences(); }
  }));

  // Tables: every cell carries its column name, so phones can show each row on its own
  body.querySelectorAll('.ol-policy-table table').forEach(table => {
    const names = [...table.querySelectorAll('thead th')].map(th => th.textContent.trim());
    if (!names.length) return;
    table.querySelectorAll('tbody tr').forEach(tr => [...tr.children].forEach((cell, i) => { if (names[i]) cell.dataset.label = names[i]; }));
    table.closest('.ol-policy-table').classList.add('is-labelled');
  });

  // 2. On this page: one entry per section heading, ids made from the heading text without its number (an id starting with a digit breaks CSS selectors) when the policy has none
  const heads = [...body.querySelectorAll('.rte h2')].filter(h => h.textContent.trim());
  if (heads.length < 3) return;
  const used = new Set();
  const slug = t => { let s = t.toLowerCase().replace(/^\d+[.)]\s+/, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section'; if (/^\d/.test(s)) s = 'section-' + s; let k = s, n = 2; while (used.has(k) || document.getElementById(k)) k = s + '-' + n++; used.add(k); return k; };
  heads.forEach(h => { if (!h.id) h.id = slug(h.textContent.trim()); else used.add(h.id); });

  const toc = document.createElement('nav');
  toc.className = 'ol-policy-toc';
  toc.setAttribute('aria-label', 'On this page');
  const details = document.createElement('details');
  const summary = document.createElement('summary');
  summary.textContent = 'On this page';
  const inner = document.createElement('div');
  const label = document.createElement('span');
  label.className = 'ol-policy-toc-label';
  label.textContent = 'On this page';
  const ol = document.createElement('ol');
  const links = heads.map(h => {
    const li = document.createElement('li'), a = document.createElement('a');
    a.href = '#' + h.id; a.textContent = h.textContent.trim();
    a.addEventListener('click', () => { if (matchMedia('(max-width: 999px)').matches) details.open = false; });
    li.append(a); ol.append(li); return a;
  });
  inner.append(label, ol);
  details.append(summary, inner);
  toc.append(details);
  // wide screens show the list beside the text (a closed details hides its content whatever the CSS says)
  const wide = matchMedia('(min-width: 1000px)');
  const fit = () => { details.open = wide.matches; };
  fit(); wide.addEventListener?.('change', fit);

  const layout = document.createElement('div');
  layout.className = 'ol-policy-layout';
  body.before(layout);
  layout.append(toc, body);

  // 3. Mark the section being read
  if ('IntersectionObserver' in window) {
    const current = new Map();
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => current.set(e.target, e.isIntersecting));
      const firstVisible = heads.find(h => current.get(h));
      if (!firstVisible) return;
      links.forEach(a => a.removeAttribute('aria-current'));
      const i = heads.indexOf(firstVisible);
      if (links[i]) links[i].setAttribute('aria-current', 'true');
    }, { rootMargin: '0px 0px -70% 0px' });
    heads.forEach(h => io.observe(h));
  }
})();
